import dynamic from 'next/dynamic';
import React, { useState } from 'react';
import { formatUrl, getHrefForCategLink } from '@/utils/linkUtils';
import { StoreConfModel } from '@/models';

import Icon from '@/components/common/iconedLinks/Icon';
import MillesimaLink from '@/components/common/MillesimaLink';

const CenteredModal = dynamic(() => import('@/components/layout/modals/CenteredModal'));
CenteredModal.displayName = 'CenteredModal';

import styles from './CategViewLabelBio.module.scss';
import { ENVIRONNEMENT_DATA as bioData, ENVIRONNEMENT } from '@/constants/product';

type CategViewLabelBioProps = {
  t: (k: string) => string;
  environnement: any;
  isMobileView: boolean;
  isSpirit?: boolean;
  storeConf: StoreConfModel;
  productPosition: number;
}

export const CategViewLabelBio = ({
  t, environnement = {}, isMobileView, isSpirit = false, storeConf, productPosition = 0
}: CategViewLabelBioProps): React.JSX.Element => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { value, valueId } = environnement;
  const isBiodyvinOrDemeter = valueId === ENVIRONNEMENT.BIODYVIN || valueId === ENVIRONNEMENT.DEMETER;
  const bioTitle = t('bioLabel.certificates');
  const agribioAlt = t('bioLabel.organic.alt');

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const bioIconAndLink = (val, valId) => (
    <>
      <Icon
        src={bioData[valId]?.src.icon}
        alt={val}
        className={styles['modal-content-icon']}
        height={48}
        width={48}
        lazy
      />
      <MillesimaLink
        id={`bio-label-${valId}`}
        ariaLabel={val}
        href={getHrefForCategLink(t(bioData[valId]?.href), `environnement_${valId}${isSpirit ? '_spirits' : ''}`, isSpirit)}
        as={formatUrl(t(bioData[valId]?.href), isSpirit, storeConf)}
        isWithoutContainer
        customClassName={{ link: styles.link }}
      >
        {t(bioData[valId]?.name)}
      </MillesimaLink>
    </>
  );

  const bioContent = (
    <>
      <div className={`mr-3 mb-3${isMobileView ? '' : ' ml-3'}`}>
        {bioIconAndLink(value, valueId)}
      </div>
      {isBiodyvinOrDemeter && (
        <div className={`mr-3${isMobileView ? '' : ' mb-3 ml-3'}`}>
          {bioIconAndLink(agribioAlt, ENVIRONNEMENT.AGRIBIO)}
        </div>
      )}
    </>
  );

  return value && valueId && (
    <>
      <Icon
        src={bioData[valueId]?.src.circleIcon}
        alt={value}
        onClick={toggleModal}
        width={24}
        height={24}
        className={styles.icon}
        lazy={productPosition > 0}
      />
      <CenteredModal
        opened={isModalOpen}
        title={bioTitle}
        customContent={bioContent}
        cancelAction={toggleModal}
      />
    </>
  );
};

export default CategViewLabelBio;
